module.exports = __webpack_public_path__ + "static/appleland-2a7934c872b12fc4c517c84da68127e3.png";